export const CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES = {
  ALLOWED_CHARACTERS: 'ALLOWED_CHARACTERS',
  MAX_LENGTH: 'MAX_LENGTH',
  REQUIRED: 'REQUIRED',
};
